import React, {createContext, useMemo} from 'react'

import DndManager from "../../../../../core/gd-modules/dnd/managers/dnd-manager"
import MenuProjects_DndPreviewLayer from "./preview-layer"

export const MenuProjectsDndContext = createContext<DndManager | null>(null)

type Props = {
    children?: any
}

// One DndManager for the whole tree. Every nesting level registers its rows as drop targets with this
// same manager, which is what makes dropping into a different parent possible - a manager per level
// (what ReorderList does) can only ever see its own siblings.
//
// Rows rendered outside a root (starred, pins, search) find no manager in the context and fall back
// to being plain rows.
export default function MenuProjects_DndRoot(props: Props) {

    const dndManager = useMemo(() => {
        return new DndManager()
    }, [])

    return (
        <MenuProjectsDndContext.Provider value={dndManager}>
            {props.children}

            <MenuProjects_DndPreviewLayer dndManager={dndManager}/>
        </MenuProjectsDndContext.Provider>
    )
}
